import { FraudCheckResultsResponse } from '@percent/admin-dashboard/api/types'

export const getFailedChecksCount = (fraudCheckResults?: FraudCheckResultsResponse | null): number =>
  fraudCheckResults?.checkResults.filter(c => c.result === 'fail').length ?? 0
